
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";
import { MessageSquare } from "lucide-react";

interface MessageDetailDialogProps {
  message: {
    id: string;
    customerId: string;
    content: string;
    date: string;
    status: string;
    template?: string;
  } | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function MessageDetailDialog({ message, open, onOpenChange }: MessageDetailDialogProps) {
  if (!message) return null;
  
  // Determine status color
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Lida':
        return 'bg-green-100 text-green-800';
      case 'Entregue':
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-yellow-100 text-yellow-800';
    }
  };

  const formattedDate = message ? format(new Date(message.date), 'dd/MM/yyyy HH:mm:ss') : '';
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <MessageSquare className="h-5 w-5" />
            Detalhes da Mensagem
          </DialogTitle>
          <DialogDescription>
            Enviada em {formattedDate}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <h3 className="text-sm font-medium">Conteúdo</h3>
            <div className="bg-gray-50 dark:bg-gray-900 p-3 rounded-md">
              <p className="text-sm whitespace-pre-wrap">{message.content}</p>
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <h3 className="text-sm font-medium">Template</h3>
              <p className="text-sm">{message.template || "Sem template"}</p>
            </div>
            
            <div>
              <h3 className="text-sm font-medium">Status</h3>
              <Badge className={`mt-1 font-normal ${getStatusColor(message.status)}`}>
                {message.status}
              </Badge>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
